import type { AxiosInstance } from 'axios';

/**
 * Gateway for interacting with the RH API.
 */
export class RhGateway {
  constructor(
    private readonly httpClient: AxiosInstance,
    private readonly baseUrl: string,
  ) {}
}

export type { Event } from './contracts/event';
